module.exports = __webpack_public_path__ + "static/img/strona_044.c9aea17f.jpg";